import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import BaseService from "../../../../services/BaseService";
import { useLocation } from "react-router-dom";
import StaticService from "../../../../services/StaticService";

const Privacy = () => {
	const initial = {
		title_en: "",
		title_ar: "",
		description_en: "",
		description_ar: "",
	};
	const [formData, setFormData] = useState(initial);
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState("");
	const lang = useSelector((state) => state.auth?.lang);
	const staticService = new StaticService();
	const location = useLocation();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);

	useEffect(() => {
		setType(location.pathname?.slice(1));
	}, [location]);

	useEffect(() => {
		if (type) {
			setLoading(true);
			staticService
				.getList({ type: type })
				.then((res) => {
					if (res?.status) {
						let response = res?.data?.data;
						if (!!response?.length) {
							setFormData(response[0]);
						}
					} else {
						setFormData(initial);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	}, [type]);

	const submit = (e) => {
		e.preventDefault();

		let data = {
			static_page: [
				{
					title_en: formData?.title_en,
					title_ar: formData?.title_ar,
					description_en: formData?.description_en,
					description_ar: formData?.description_ar,
				},
			],
			type: type,
		};

		staticService
			.create(data)
			?.then((res) => {
				if (res?.status) {
					toast.success(res?.data?.message);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang][type]}
						</span>
					</div>
				</div>
			</div>

			<div>
				{loading && (
					<div style={{ height: "400px" }}>
						<Loader />
					</div>
				)}
				{!loading && (
					<AvForm className="form-horizontal" onValidSubmit={submit}>
						<Row className="mb-3">
							<Col md={12}>
								<label className="text-label">
									{Translate[lang]?.title} ({Translate[lang]?.english})
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.english}
									bsSize="lg"
									style={{
										height: "100px",
									}}
									name={`english_title`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.title_en}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											title_en: e.target.value,
										}))
									}
								/>
							</Col>
							<Col md={12}>
								<label className="text-label">
									{Translate[lang]?.title} ({Translate[lang]?.arabic})
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.arabic}
									bsSize="lg"
									style={{
										height: "100px",
									}}
									name={`title_ar`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.title_ar}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											title_ar: e.target.value,
										}))
									}
								/>
							</Col>

							<Col md={12}>
								<label className="text-label">
									{Translate[lang]?.description} ({Translate[lang]?.english})
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.english}
									bsSize="lg"
									style={{
										height: "150px",
									}}
									name={`description_en`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.description_en}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											description_en: e.target.value,
										}))
									}
								/>
							</Col>
							<Col md={12}>
								<label className="text-label">
									{Translate[lang]?.description} ({Translate[lang]?.arabic})
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.arabic}
									bsSize="lg"
									style={{
										height: "150px",
									}}
									name={`description_ar`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.description_ar}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											description_ar: e.target.value,
										}))
									}
								/>
							</Col>
						</Row>
						{/* {isExist("add_cms") && ( */}
						<Button variant="primary" type="submit" disabled={loading}>
							{Translate[lang]?.save}
						</Button>
						{/* )} */}
					</AvForm>
				)}
			</div>
		</div>
	);
};
export default Privacy;
